/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_SubtotalInputs */

const vi_receipt_subtotal = /** @type {(inputs: Receipt_SubtotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng tiền hàng`)
};

/**

* @param {Receipt_SubtotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_subtotal = /** @type {((inputs?: Receipt_SubtotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_SubtotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_subtotal(inputs)
});